import { ChainId, Token } from 'vvs-sdk'
import { serializeToken } from 'state/user/hooks/helpers'
import { SerializedToken } from './types'

const { MAINNET, TESTNET } = ChainId

type TokenList = Record<string, Token> & (typeof testnetTokens | typeof mainnetTokens)

interface SerializedTokenList {
  [symbol: string]: SerializedToken
}

export const mainnetTokens = {
  workbench: new Token(
    MAINNET,
    process.env.REACT_APP_WORKBENCH_ADDRESS_MAINNET || '0x6a2d178585806De5A2e5E7F9acFCE44680637284',
    18,
    'WORKBENCH',
    'WORKBENCH',
    'https://vvs.finance/',
  ),
  cro: new Token(MAINNET, '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23', 18, 'CRO', 'CRO Token', 'https://crypto.org/'),
  wcro: new Token(
    MAINNET,
    '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
    18,
    'WCRO',
    'Wrapped CRO',
    'https://crypto.org/',
  ),
  vvs: new Token(MAINNET, '0x2D03bECE6747ADC00E1a131BBA1469C15fD11e03', 18, 'VVS', 'VVS', 'https://vvs.finance/'),
  eth: new Token(
    MAINNET,
    '0xe44Fd7fCb2b1581822D0c862B68222998a0c299a',
    18,
    'ETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  weth: new Token(
    MAINNET,
    '0xe44Fd7fCb2b1581822D0c862B68222998a0c299a',
    18,
    'WETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  usdc: new Token(
    MAINNET,
    '0xc21223249CA28397B4B6541dfFaEcC539BfF0c59',
    6,
    'USDC',
    'USD Coin',
    'https://www.circle.com/en/usdc',
  ),
  wbtc: new Token(
    MAINNET,
    '0x062E66477Faf219F25D27dCED647BF57C3107d52',
    8,
    'WBTC',
    'Wrapped BTC',
    'https://bitcoin.org/en/',
  ),
  usdt: new Token(MAINNET, '0x66e428c3f67a68878562e79A0234c1F83c208770', 6, 'USDT', 'Tether USD', 'https://tether.to/'),
  shib: new Token(
    MAINNET,
    '0xbED48612BC69fA1CaB67052b42a95FB30C1bcFee',
    18,
    'SHIB',
    'Shiba Inu',
    'https://shibatoken.com/',
  ),
  bifi: new Token(
    MAINNET,
    '0xe6801928061CDbE32AC5AD0634427E140EFd05F9',
    18,
    'BIFI',
    'Beefy.finance',
    'https://www.beefy.finance/',
  ),
  dai: new Token(
    MAINNET,
    '0xF2001B145b43032AAF5Ee2884e456CCd805F677D',
    18,
    'DAI',
    'Dai Stablecoin',
    'https://makerdao.com/',
  ),
  doge: new Token(MAINNET, '0x1a8E39ae59e5556B56b76fCBA98d22c9ae557396', 8, 'DOGE', 'Dogecoin', 'http://dogecoin.com/'),
  atom: new Token(MAINNET, '0xB888d8Dd1733d72681b30c00ee76BDE93ae7aa93', 6, 'ATOM', 'ATOM', 'http://cosmos.network/'),
  tonic: new Token(
    MAINNET,
    '0xDD73dEa10ABC2Bff99c60882EC5b2B81Bb1Dc5B2',
    18,
    'TONIC',
    'Tectonic',
    'https://tectonic.finance/',
  ),
  link: new Token(
    MAINNET,
    '0xBc6f24649CCd67eC42342AccdCECCB2eFA27c9d9',
    18,
    'LINK',
    'Chainlink',
    'https://chain.link/',
  ),
  enj: new Token(MAINNET, '0x0A92ea8a197919aCb9BC26660Ed0D43D01ed26b7', 18, 'ENJ', 'Enjin', 'https://enjin.io/'),
  elon: new Token(
    MAINNET,
    '0x02DCcaf514C98451320a9365C5b46C61d3246ff3',
    18,
    'ELON',
    'Dogelon Mars',
    'https://dogelonmars.com/',
  ),
  single: new Token(
    MAINNET,
    '0x0804702a4E749d39A35FDe73d1DF0B1f1D6b8347',
    18,
    'SINGLE',
    'SINGLE Token',
    'https://singlefinance.io/',
  ),
  dot: new Token(MAINNET, '0x994047FE66406CbD646cd85B990E11D7F5dB8fC7', 10, 'DOT', 'DOT', 'https://polkadot.network/'),
  ada: new Token(MAINNET, '0x0e517979C2c1c1522ddB0c73905e0D39b3F990c0', 6, 'ADA', 'Cardano', 'https://cardano.org/'),
  radar: new Token(
    MAINNET,
    '0xa58e3AeAeA3292c3E260378e55E9684C59E7A27a',
    18,
    'RADAR',
    'DappRadar',
    'https://dappradar.com/',
  ),
  derc: new Token(
    MAINNET,
    '0x98616a1427a1734DaEbA1E1894db48051244A065',
    18,
    'DERC',
    'DeRace Token',
    'https://www.derace.com/',
  ),
  pendle: new Token(
    MAINNET,
    '0x49c3bBB239f4FB44327073510f4bA72D207a81D6',
    18,
    'PENDLE',
    'Pendle',
    'https://www.pendle.finance/',
  ),
  tusd: new Token(
    MAINNET,
    '0x87EFB3ec1576Dec8ED47e58B832bEdCd86eE186e',
    18,
    'TUSD',
    'TrueUSD',
    'https://www.trueusd.com/',
  ),
  xlm: new Token(MAINNET, '0x747d6C858168B8cD6e537160320b5dE58FD3367C', 7, 'XLM', 'XLM', 'https://www.stellar.org/'),
  eos: new Token(MAINNET, '0xA37caA841072a305a0799718aFA16cd504C52118', 4, 'EOS', 'EOS', 'https://eos.io/'),
  xvvs: new Token(MAINNET, '0x7fE4DB9063b7Dd7ba55313B9c258070bEd2C143A', 18, 'xVVS', 'xvvs', 'https://vvs.finance/'),
  qrdo: new Token(
    MAINNET,
    '0x70BB395F1A824D9a3F9D510C25e699cEaf603dEc',
    8,
    'QRDO',
    'Qredo Token',
    'https://www.qredo.com/',
  ),
  ape: new Token(MAINNET, '0x9C62F89a8C9907582f21205Ce90443730361EA05', 18, 'APE', 'ApeCoin', 'https://apecoin.com/'),
  ali: new Token(MAINNET, '0x45C135C1CDCE8d25A3B729A28659561385C52671', 18, 'ALI', 'Alethea AI', 'https://alethea.ai/'),
  versa: new Token(
    MAINNET,
    '0x00D7699b71290094CcB1a5884cD835bD65a78c17',
    18,
    'VERSA',
    'VersaGames',
    'https://versagames.io/',
  ),
  matic: new Token(
    MAINNET,
    '0xf78a326ACd53651F8dF5D8b137295e434B7c8ba5',
    18,
    'MATIC',
    'MATIC',
    'https://polygon.technology/',
  ),
  v3tonic: new Token(
    MAINNET,
    '0xA29EB0318F522ca98FdB5cEdc0c7549526625517',
    18,
    'V3TONIC',
    'V3TONIC',
    'https://www.v3s.finance/',
  ),
  v3cro: new Token(
    MAINNET,
    '0xdB04627376661D678Cf6efFBad509D631B0050ae',
    18,
    'V3CRO',
    'V3CRO',
    'https://www.v3s.finance/',
  ),
  v3dusd: new Token(
    MAINNET,
    '0xD9EF024bb157C2B897a95007a1b73543712f3b48',
    18,
    'V3DUSD',
    'V3DUSD',
    'https://www.v3s.finance/',
  ),
  vshare: new Token(
    MAINNET,
    '0xdcC261c03cD2f33eBea404318Cdc1D9f8b78e1AD',
    18,
    'VSHARE',
    'VSHARE',
    'https://www.v3s.finance/',
  ),
  v3s: new Token(MAINNET, '0xC7e99a2f064Cf86aF91Db252a9D8Bc16e6fE7427', 18, 'V3S', 'V3S', 'https://www.v3s.finance/'),
  dark: new Token(
    MAINNET,
    '0x83b2AC8642aE46FC2823Bc959fFEB3c1742c48B5',
    18,
    'DARK',
    'DarkCrypto',
    'https://www.darkcrypto.finance/',
  ),
  sky: new Token(
    MAINNET,
    '0x9D3BBb0e988D9Fb2d55d07Fe471Be2266AD9c81c',
    18,
    'SKY',
    'DarkCrypto Share',
    'https://www.darkcrypto.finance/',
  ),
  dusd: new Token(
    MAINNET,
    '0x6582C738660bf0701f05b04DcE3c4E5Fcfcda47a',
    18,
    'DUSD',
    'Darkness Dollar',
    'https://www.darkcrypto.finance/',
  ),
  ness: new Token(
    MAINNET,
    '0xE727240728C1a5f95437b8b50AFDd0EA4AE5F0c8',
    18,
    'NESS',
    'Darkness Share',
    'https://www.darkcrypto.finance/',
  ),
  akt: new Token(MAINNET, '0x39a65A74Dc5A778Ff93d1765Ea51F57BC49c81B3', 6, 'AKT', 'AKT', 'https://akash.network/'),
  ftm: new Token(
    MAINNET,
    '0x63888BaFc5975630E4E5CF50c3845a3250115F64',
    18,
    'FTM',
    'Fantom Token',
    'https://fantom.foundation/',
  ),
  sol: new Token(MAINNET, '0xc9DE0F3e08162312528FF72559db82590b481800', 9, 'SOL', 'Solana', 'https://solana.com/'),
  avax: new Token(
    MAINNET,
    '0x8d58088D4E8Ffe75A8b6357ba5ff17B93B912640',
    9,
    'AVAX',
    'Avalanche',
    'https://www.avax.network/',
  ),
  crv: new Token(
    MAINNET,
    '0xfEf44a0C77eca218F443382d3128a7A251a8C542',
    18,
    'CRV',
    'Curve DAO Token',
    'https://curve.fi/',
  ),
  alice: new Token(
    MAINNET,
    '0x46EfE38eC0558C48352e2eBc85AF3bd2E87Fb2A1',
    6,
    'ALICE',
    'My Neighbor Alice',
    'https://www.myneighboralice.com/',
  ),
  gala: new Token(MAINNET, '0x7A887D4f8a3221e1aaFA2f4435b774D51429A3e1', 8, 'GALA', 'GALA', 'https://app.gala.games/'),
  ltc: new Token(MAINNET, '0x9d97Be214b68C7051215BB61059B4e299Cd792c3', 8, 'LTC', 'Litecoin', 'https://litecoin.com/'),
  icp: new Token(
    MAINNET,
    '0x8Bf3E654075E269c1C415e4889C12D9837452be0',
    8,
    'ICP',
    'Internet Computer',
    'https://internetcomputer.org/',
  ),
  sand: new Token(
    MAINNET,
    '0x9097eA65B55dfC7383A7EFB465e8fFC18D46e784',
    18,
    'SAND',
    'The Sandbox',
    'https://www.sandbox.game/',
  ),
  bch: new Token(
    MAINNET,
    '0x7589B70aBb83427bb7049e08ee9fC6479ccB7a23',
    8,
    'BCH',
    'Bitcoin Cash',
    'https://bitcoincash.org/',
  ),
  algo: new Token(
    MAINNET,
    '0x2fEfe47989214c2e74A6319076c138d395681407',
    6,
    'ALGO',
    'Algorand',
    'https://www.algorand.com/',
  ),
  mana: new Token(
    MAINNET,
    '0x6Ed8c99E5c6B2c551e012E4272d8f3d1DF23a71A',
    18,
    'MANA',
    'Decentraland',
    'https://decentraland.org/',
  ),
  slp: new Token(
    MAINNET,
    '0xc00DcfBc7aC19B7210fa9c73b5F1d2E0f7E62711',
    0,
    'SLP',
    'Smooth Love Potion',
    'https://axieinfinity.com/',
  ),
  flow: new Token(MAINNET, '0x22EF9d73EA90E774CfB21fADDF84b37BD54FE7a6', 8, 'FLOW', 'Flow', 'https://www.onflow.org/'),
  imx: new Token(
    MAINNET,
    '0x8f27dB0E597B67F33d5Fb58D5EEcD6A3CC780942',
    18,
    'IMX',
    'Immutable X',
    'https://www.immutable.com/',
  ),
  omg: new Token(
    MAINNET,
    '0x5a56509C61ad80680caF5b3B980E6C88319eeE33',
    18,
    'OMG',
    'OMG Network',
    'https://omg.network/',
  ),
  zil: new Token(
    MAINNET,
    '0xc70ed252E55d68A7020A754Fb92Fa5c68e3c199f',
    12,
    'ZIL',
    'Ziliqa',
    'https://www.zilliqa.com/',
  ),
  axs: new Token(
    MAINNET,
    '0xE27753e456AbA584f10aCEf0B4e367EF38f01e14',
    18,
    'AXS',
    'Axie Infinity Shards',
    'https://axieinfinity.com/',
  ),
  uni: new Token(MAINNET, '0x16aD43896f7C47a5d9Ee546c44A22205738B329c', 18, 'UNI', 'Uniswap', 'https://uniswap.org/'),
  argo: new Token(
    MAINNET,
    '0x47A9D630dc5b28F75d3AF3be3AAa982512Cd89Aa',
    18,
    'ARGO',
    'Argo Protocol',
    'https://www.argofinance.money/',
  ),
  hnt: new Token(MAINNET, '0x61426C150207AbF8a215f3377a0819dDcA842aF3', 8, 'HNT', 'Helium', 'https://www.helium.com/'),
  knc: new Token(
    MAINNET,
    '0xd73EBf885C4157D3E88c6D87ad3b8018B4a32fEF',
    18,
    'KNC',
    'Kyber Network Crystal',
    'https://kyber.network/',
  ),
  aave: new Token(MAINNET, '0xE657b115bc45c0786274c824f83e3e02CE809185', 18, 'AAVE', 'Aave', 'https://aave.com/'),
  lrc: new Token(MAINNET, '0xAF760dE3201fEeD80FEeA59FB16A8360C8c4d1a2', 18, 'LRC', 'Loopring', 'https://loopring.org/'),
  xtz: new Token(MAINNET, '0x9D5a7d02D51Dc523197e62c2865907dbB53642Af', 6, 'XTZ', 'Tezos', 'https://tezos.com/'),
  dar: new Token(
    MAINNET,
    '0x5893915Fe3d15e4004F7232c80036bFa92aCa564',
    6,
    'DAR',
    'Mines of Dalarnia',
    'https://www.minesofdalarnia.com/',
  ),
  grt: new Token(
    MAINNET,
    '0x4c523222Cd0DE11616F7aD685f24145B9FaF7996',
    18,
    'GRT',
    'The Graph',
    'https://thegraph.com/',
  ),
  chz: new Token(MAINNET, '0x4E4F362170bFb88D3c9378FF7818d93fC2fbd257', 18, 'CHZ', 'Chiliz', 'https://www.chiliz.com/'),
  rune: new Token(
    MAINNET,
    '0x171C8AAA57D0107d0187f54Ccf4CC03406E76a4E',
    8,
    'RUNE',
    'THORChain',
    'https://thorchain.org/',
  ),
  ksm: new Token(MAINNET, '0x0BD48A8A9565385649D9d7f1c945D1d0C4543E26', 12, 'KSM', 'Kusama', 'https://kusama.network/'),
  inj: new Token(
    MAINNET,
    '0x4E05F3C7ee6155e3add224470E1c4583D4F424A3',
    18,
    'INJ',
    'Injective',
    'https://injective.com/',
  ),
  neo: new Token(MAINNET, '0xB3fc0777738168ce33B228F1831EEbD5A81aaDB3', 0, 'NEO', 'Neo', 'https://neo.org/'),
  yfi: new Token(
    MAINNET,
    '0x7bDF81a86f4AA8B442Ca05670Cbf296BB22Bc7bB',
    18,
    'YFI',
    'yearn.finance',
    'https://yearn.finance/',
  ),
  sushi: new Token(
    MAINNET,
    '0xdb3de0AAC8A39490932FA19c2e32F179368Ab840',
    18,
    'SUSHI',
    'SushiSwap',
    'https://www.sushi.com/',
  ),
  qnt: new Token(
    MAINNET,
    '0x7d54F4E05f273a9317f723997612Ed64eF53C900',
    18,
    'QNT',
    'Quant',
    'https://www.quant.network/',
  ),
  mkr: new Token(MAINNET, '0xab9Cf8C5A9B6Cf5215c82D088D37d04bB146704A', 18, 'MKR', 'Maker', 'https://makerdao.com/'),
  hot: new Token(MAINNET, '0xc4010CfB5172D82A348bcBC8cD543733c1e9BF89', 18, 'HOT', 'Holo', 'https://holo.host/'),
  celr: new Token(
    MAINNET,
    '0xfA0235feF8644C107f7e531Fa9CFe0613Fbe8909',
    18,
    'CELR',
    'Celer Network',
    'https://www.celer.network/',
  ),
  ren: new Token(MAINNET, '0x2b4eE166a125E01Aba019885932C944cEfED2932', 18, 'REN', 'Ren', 'https://renproject.io/'),
  qtum: new Token(MAINNET, '0x32529346958711B3beF92B96507C14821e50C9c8', 8, 'QTUM', 'Qtum', 'https://www.qtum.org/'),
  bat: new Token(
    MAINNET,
    '0x2F712E0a6f92e3f865EaEb86f07BAFc67974d26c',
    18,
    'BAT',
    'Basic Attention Token',
    'https://basicattentiontoken.org/',
  ),
  srm: new Token(
    MAINNET,
    '0xB858e614779f148992949A3b15E6127dDA204ca4',
    6,
    'SRM',
    'Serum',
    'https://www.projectserum.com/',
  ),
  dydx: new Token(MAINNET, '0x4442C740cc5B47F032983106E66E3C9dC945676C', 18, 'DYDX', 'dYdX', 'https://dydx.exchange/'),
  uma: new Token(MAINNET, '0x33564807CC70c6422124d867B344D7b90bF21A76', 18, 'UMA', 'UMA', 'https://umaproject.org/'),
  chr: new Token(MAINNET, '0xcdee9300A1527E0000b054320D371A9C8c4a8AF6', 6, 'CHR', 'Chromia', 'https://chromia.com/'),
  efi: new Token(
    MAINNET,
    '0x47E16f9EE811d3651D979941325c545Da6385daF',
    18,
    'EFI',
    'Efinity Token',
    'https://efinity.io/',
  ),
  ens: new Token(
    MAINNET,
    '0xA0913e0D7A85954e89452e7Ccb8d1235db74C330',
    18,
    'ENS',
    'Ethereum Name Service',
    'https://ens.domains/',
  ),
  pla: new Token(
    MAINNET,
    '0x044597363b0054986aE4289d25CD7D0D451766Fc',
    18,
    'PLA',
    'PlayDapp Token',
    'https://playdapp.io/',
  ),
  stx: new Token(MAINNET, '0x30BBA7b57952E7028c47d5c6AB295D0Da7139eF9', 6, 'STX', 'Stacks', 'https://www.stacks.co/'),
  '1inch': new Token(
    MAINNET,
    '0xEea900FE18F77593C7D7C105fBa9bd714164AC95',
    18,
    '1INCH',
    '1INCH Token',
    'https://1inch.io/',
  ),
  jasmy: new Token(
    MAINNET,
    '0x227EdF65f866255A0ED4B5b453fe43A41182EC3A',
    18,
    'JASMY',
    'JasmyCoin',
    'https://www.jasmy.co.jp/en_company.html',
  ),
  rndr: new Token(
    MAINNET,
    '0xEaEA1a708DaB6f732E35F06588293204318ac48F',
    18,
    'RNDR',
    'Render Token',
    'https://rendertoken.com/',
  ),
  comp: new Token(
    MAINNET,
    '0x4Fb1af9D09DB3fbbda96071EaE0aeae6E871F9AC',
    18,
    'COMP',
    'Compound',
    'https://compound.finance/',
  ),
  // api3: new Token(MAINNET, '0xD7EaFAed164786010B7b2c4D592BAc1c9D941E2d', 18, 'API3', 'API3', 'https://api3.org/'),
  ankr: new Token(
    MAINNET,
    '0x1FE0f470736548794b47AFe5613d3A309d964d3c',
    18,
    'ANKR',
    'Ankr Network',
    'https://www.ankr.com/',
  ),
  snx: new Token(
    MAINNET,
    '0x9Aa8F72dd2C06EAff0113bD0380255E1fbDAeaC4',
    18,
    'SNX',
    'Synthetix Network Token',
    'https://synthetix.io/',
  ),
  agld: new Token(
    MAINNET,
    '0xD3BB5C6961157eB4eb03658Dc5D4144808828168',
    18,
    'AGLD',
    'Adventure Gold',
    'https://www.lootproject.com/',
  ),
  spell: new Token(
    MAINNET,
    '0xB37e6457C17A370b2eAEb40849d20dcaEa5f7e92',
    18,
    'SPELL',
    'Spell Token',
    'https://abracadabra.money/',
  ),
  xyo: new Token(MAINNET, '0x211153266F15F9314B214A7dd614d90f850a8D6a', 18, 'XYO', 'XY Oracle', 'https://xyo.network/'),
  hbar: new Token(MAINNET, '0xe0C7226a58f54db71eDc6289Ba2dc80349B41974', 8, 'HBAR', 'Hedera', 'https://hedera.com/'),
  aurora: new Token(
    MAINNET,
    '0xB4f1D9A65816da7e112F11C9A2900b8C5beeD525',
    18,
    'AURORA',
    'Aurora',
    'https://aurora.dev/',
  ),
  // busd: new Token(
  //   MAINNET,
  //   '0xC74D59A548ecf7fc1754bb7810D716E9Ac3e3AE5',
  //   18,
  //   'BUSD',
  //   'Binance USD',
  //   'https://www.binance.com/en/busd',
  // ),
  ygg: new Token(
    MAINNET,
    '0xfF9620d9F80F80056cbE4Bb84403a9E9C5174213',
    18,
    'YGG',
    'Yield Guild Games Token',
    'https://yieldguild.io/',
  ),
  ckb: new Token(
    MAINNET,
    '0x5dEED46f39c485bA03b61d83763d0f6357dc4737',
    8,
    'CKB',
    'Nervos Network',
    'https://www.nervos.org/',
  ),
  boson: new Token(
    MAINNET,
    '0x813EFfe620c71Bd1b522a8E6FA74C0e46C80DA2E',
    8,
    'BOSON',
    'Boson Protocol',
    'https://www.bosonprotocol.io/',
  ),
  cspr: new Token(
    MAINNET,
    '0x15a9e70f166BcaAA7bfF094d865cE5aAa73A2A58',
    9,
    'CSPR',
    'Casper',
    'https://casper.network/',
  ),
  ar: new Token(MAINNET, '0xeB6B3AEdA7A2705fAC5e2350fA4D71a64b393b37', 12, 'AR', 'Arweave', 'https://www.arweave.org/'),
  ogn: new Token(
    MAINNET,
    '0x78E9974A74d6c980De4E3F8039248320c5A2d714',
    18,
    'OGN',
    'Origin Protocol',
    'https://www.originprotocol.com/',
  ),
  paxg: new Token(
    MAINNET,
    '0x81749e7258f9e577f61f49ABeeB426b70F561b89',
    18,
    'PAXG',
    'PAX Gold',
    'https://paxos.com/paxgold/',
  ),
}
// FIXME tokens for testnet and mainnet
export const testnetTokens = {
  workbench: new Token(
    TESTNET,
    process.env.REACT_APP_WORKBENCH_ADDRESS_TESTNET || '0x2996B1677460e6Fd2b76B4B42E341CA5861a0018',
    18,
    'WORKBENCH',
    'WORKBENCH',
    'https://vvs.finance/',
  ),
  cro: new Token(TESTNET, '0x6a3173618859C7cd40fAF6921b5E9eB6A76f1fD4', 18, 'CRO', 'CRO', 'https://crypto.org/'),
  wcro: new Token(
    TESTNET,
    '0x6a3173618859C7cd40fAF6921b5E9eB6A76f1fD4',
    18,
    'WCRO',
    'Wrapped CRO',
    'https://crypto.org/',
  ),
  vvs: new Token(TESTNET, '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a', 18, 'VVS', 'VVS', 'https://vvs.finance/'),
  eth: new Token(
    TESTNET,
    '0x441d72d584b16105FF1C68DC8bc4517F4DC13E55',
    18,
    'ETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  weth: new Token(
    TESTNET,
    '0x441d72d584b16105FF1C68DC8bc4517F4DC13E55',
    18,
    'WETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  usdc: new Token(
    TESTNET,
    '0x321106E51b78E0E9CEBcFeC63C5250F0F3CcB82b',
    6,
    'USDC',
    'USD Coin',
    'https://www.circle.com/en/usdc',
  ),
  wbtc: new Token(
    TESTNET,
    '0xFFc8ce84a196420d7bCCDEe980c65364eD1f389F',
    18,
    'WBTC',
    'Wrapped BTC',
    'https://bitcoin.org/en/',
  ),
  usdt: new Token(TESTNET, '0x914a8825B29a04ae687625eCDa20B67abd0B58b1', 6, 'USDT', 'Tether USD', 'https://tether.to/'),
  shib: new Token(
    TESTNET,
    '0xF6dF880DF3571ab39a3E09a74D8DB00107e9A43E',
    18,
    'SHIB',
    'Shiba Inu',
    'https://shibatoken.com/',
  ),
  coffee: new Token(
    TESTNET,
    '0x2DA12B663DAAbB01319c75F4ACC121618bA7785C',
    18,
    'COFFEE',
    'Coffee',
    'https://vvs.finance/',
  ),
  fish_ball: new Token(
    TESTNET,
    '0xc7cB072748dd938c1014c4253Ba72a806c35B363',
    18,
    'FISH_BALL',
    'Fish Ball',
    'https://vvs.finance/',
  ),
  rich_man: new Token(
    TESTNET,
    '0xBA9753472180A44bdB6045a2DAbBb2f63f7B7E95',
    18,
    'RICH_MAN',
    'Rich Man',
    'https://vvs.finance/',
  ),
  poor_man: new Token(
    TESTNET,
    '0xf21D12f075ee0FCC6931d660EbD5a65abd9a354B',
    18,
    'POOR_MAN',
    'Pool Man',
    'https://vvs.finance/',
  ),
  banana: new Token(
    TESTNET,
    '0x75a98c7ED2D451557D6E22F7f75958DA43E0F143',
    18,
    'BANANA',
    'Banana',
    'https://vvs.finance/',
  ),
  orange: new Token(
    TESTNET,
    '0xB7189FAaaa0Cd9a6D006A454b527A54f97e3F5d8',
    18,
    'ORANGE',
    'Orange',
    'https://vvs.finance/',
  ),
  salad: new Token(TESTNET, '0x755979387ecDF3d26145C2E9d0BBC9c008409c35', 18, 'SALAD', 'Salad', 'https://vvs.finance/'),
  hamburger: new Token(
    TESTNET,
    '0x35f38e0eAb6A9d4EE28956665b20B133955887b6',
    18,
    'HAMBURGER',
    'Hamburger',
    'https://vvs.finance/',
  ),
  pizza: new Token(TESTNET, '0x5da960c75BD0FeC0eEaf3dc13f92279161b694F4', 18, 'PIZZA', 'Pizza', 'https://vvs.finance/'),
  muffin: new Token(
    TESTNET,
    '0xeCEd065C7AeAA2daff3199ead1544511b2612022',
    18,
    'MUFFIN',
    'Muffin',
    'https://vvs.finance/',
  ),
  ginger: new Token(
    TESTNET,
    '0x67Bc49E7392d5467d758A4fcCA2b0246a4218F25',
    18,
    'GINGER',
    'Ginger',
    'https://vvs.finance/',
  ),
  seattle: new Token(
    TESTNET,
    '0x44B23563FCe03deeaA4e19270Fdb645a8017F260',
    18,
    'SEATTLE',
    'Seattle',
    'https://vvs.finance/',
  ),
  single: new Token(
    TESTNET,
    '0x0804702a4E749d39A35FDe73d1DF0B1f1D6b8347',
    18,
    'SINGLE',
    'SINGLE Token',
    'https://singlefinance.io/',
  ),
  start: new Token(TESTNET, '0x3cB52C062BcBDAa2E88Fbc7A21ACa7765FaA4c4c', 18, 'START', 'start', 'https://vvs.finance/'),
  start1: new Token(
    TESTNET,
    '0xC8a9c47fcC89B567784C4fCB017d266C65A6EafF',
    18,
    'START1',
    'start1',
    'https://vvs.finance/',
  ),
  start2: new Token(
    TESTNET,
    '0x02a73fC5BDC5Cf58Bd71a49880157433dfE7574E',
    6,
    'START2',
    'start2',
    'https://vvs.finance/',
  ),
  rose: new Token(TESTNET, '0x7eBDdF6c91E19283a3Ad708754ABAd7A6ad0E657', 18, 'ROSE', 'rose', 'https://vvs.finance/'),
  rose1: new Token(TESTNET, '0x401d0c4E76A0566F174321c2e85a618CA718E112', 18, 'ROSE1', 'rose1', 'https://vvs.finance/'),
  rose2: new Token(TESTNET, '0xccaca9e0741045a56900a384107da93d27df6c3d', 18, 'ROSE2', 'rose2', 'https://vvs.finance/'),
  xvvs: new Token(TESTNET, '0x99cEEF14F0Db80E6f691AF925cE1b3759cB54ecC', 18, 'xVVS', 'xvvs', 'https://vvs.finance/'),
  versa: new Token(
    TESTNET,
    '0x29F7Dec75943DC4144A90Ca70aeaB3651918D423',
    18,
    'VERSA',
    'versa',
    'https://versagames.io/',
  ),
  argo: new Token(
    TESTNET,
    '0xC3C63A9b6Dc4945cf3B35C79EE4058d3A220E22B',
    18,
    'ARGO',
    'ARGO',
    'https://www.argofinance.money/',
  ),
}

export const getTokens = (chainId = process.env.REACT_APP_CHAIN_ID): TokenList => {
  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (parseInt(chainId, 10) === ChainId.TESTNET) {
    // return Object.keys(mainnetTokens).reduce((accum, key) => {
    //   return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    // }, {})
    return testnetTokens // FIXME avoid this mainnet override testnet hack
  }

  return mainnetTokens
}

export const tokensByAddress = (): Record<string, Token> => {
  const tokenList = getTokens()
  const tokenListByAddress: Record<string, Token> = Object.keys(tokenList).reduce((accum, key) => {
    return { ...accum, [tokenList[key].address]: tokenList[key] }
  }, {})

  return tokenListByAddress
}

export const serializeTokens = (chainId = process.env.REACT_APP_CHAIN_ID): SerializedTokenList => {
  const unserializedTokens = getTokens(chainId)
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export const serializeTokensByAddress = (): SerializedTokenList => {
  const unserializedTokens = getTokens()
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [unserializedTokens[key].address]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export default getTokens()
